import { Controller } from "@hotwired/stimulus"

// Shared modal for moving a custom report between parents.
// The trigger button supplies the per-report context via data attributes:
//   data-report-label, data-report-type-label, data-form-action
export default class extends Controller {
  static targets = ["dialog", "form", "label", "select"]

  open(event) {
    event.preventDefault()
    const button = event.currentTarget
    this.formTarget.action = button.dataset.formAction
    this.labelTarget.textContent = button.dataset.reportLabel
    this.resetSelect()
    this.dialogTarget.showModal()
    document.body.style.overflow = "hidden"
  }

  close() {
    this.dialogTarget.close()
  }

  // Bound to the dialog's own `close` event so Esc — which closes a native dialog
  // without going through close() — also restores page scrolling.
  closed() {
    document.body.style.overflow = ""
  }

  // The select is wrapped by SlimSelect, which keeps its own store: writing the
  // native value alone leaves the previous choice on screen.
  resetSelect() {
    const controller = this.application.getControllerForElementAndIdentifier(
      this.selectTarget,
      "select",
    )
    if (controller) controller.clear()
    else this.selectTarget.value = ""
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
